import { render, staticRenderFns } from "./SubmitReview.vue?vue&type=template&id=7449d75a&"
import script from "./SubmitReview.vue?vue&type=script&lang=js&"
export * from "./SubmitReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports